module.exports = __webpack_public_path__ + "img/au.2507d23c.jpg";